const STORAGE_KEY = 'favorite-faction-selection';

const readStore = () => {
  if (typeof window === 'undefined') return {};

  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : {};
  } catch (storageError) {
    console.warn('Errore lettura preferenze fazione:', storageError);
    return {};
  }
};

const writeStore = (nextStore) => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextStore));
  } catch (storageError) {
    console.warn('Errore salvataggio preferenze fazione:', storageError);
  }
};

const buildStoredFaction = (faction) => {
  if (!faction?.id) return null;

  return {
    id: faction.id,
    name: faction.name || 'Senza nome',
    imageUrl: faction.imageUrl || '',
    roster: faction.roster || null,
    rosterId: faction.rosterId || null,
    creditsLeft: faction.creditsLeft || 0,
    ownerUid: faction.ownerUid || null,
    accumulatedPoints: faction.accumulatedPoints || 0,
    malus: faction.malus || 0,
    wrestlers: Array.isArray(faction.wrestlers) ? faction.wrestlers : [],
    wrestlerIds: Array.isArray(faction.wrestlerIds) ? faction.wrestlerIds : [],
    costs: Array.isArray(faction.costs) ? faction.costs : []
  };
};

export const readFavoriteFactionSelection = (uid) => {
  if (!uid) return null;

  const store = readStore();
  return store[uid] || null;
};

export const saveFavoriteFactionSelection = ({
  uid,
  favoriteFactionId,
  faction = null
}) => {
  if (!uid) return;

  const store = readStore();
  store[uid] = {
    favoriteFactionId,
    faction: buildStoredFaction(faction),
    updatedAt: Date.now()
  };
  writeStore(store);
};

export const clearFavoriteFactionSelection = (uid) => {
  if (!uid) return;

  const store = readStore();
  delete store[uid];
  writeStore(store);
};
